// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"_d2a5cdb","open":"_9dee9a3","icon":"_85a50ec"};